import React from 'react';
import ReactDOM from 'react-dom';
import soundManager from '../utils/soundEffects';

const ValorantModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const handleClose = () => {
    soundManager.playClick();
    onClose();
  };

  // Google Drive video link
  const videoId = '1xX9HYKKoKLZn2xKHvXI7teMG9F8ftdiu';
  const embedUrl = `https://drive.google.com/file/d/${videoId}/preview`;
  const directUrl = `https://drive.google.com/file/d/${videoId}/view?usp=sharing`;

  const modalContent = (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 99999,
        padding: '20px'
      }}
    >
      {/* Backdrop */}
      <div 
        onClick={handleClose}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.75)',
          zIndex: 99998
        }}
      />
      
      {/* Modal */}
      <div 
        style={{
          position: 'relative',
          width: '100%',
          maxWidth: '700px',
          zIndex: 100000
        }}
      >
        <div style={{
          background: 'rgba(192, 192, 192, 0.95)',
          border: '3px solid',
          borderColor: '#ffffff #000000 #000000 #ffffff',
          boxShadow: '4px 4px 0 rgba(0,0,0,0.5)'
        }}>
          {/* Header */}
          <div style={{
            background: 'linear-gradient(90deg, #6a1535, #b23965, #f9a5b9)',
            color: 'white',
            padding: '4px 6px',
            fontWeight: 'bold',
            fontSize: '14px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <span>🎮 Valorant Profile</span>
            <button 
              onClick={handleClose}
              style={{
                background: 'transparent',
                border: 'none',
                color: 'white',
                fontSize: '16px',
                fontWeight: 'bold',
                cursor: 'pointer',
                padding: '0 8px'
              }}
            >
              ✕
            </button>
          </div>
          
          {/* Body */}
          <div style={{
            background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
            color: '#e0e0e0',
            padding: '16px',
            margin: '3px',
            border: '2px inset #dfdfdf'
          }}>
            {/* Header Section */}
            <div style={{ textAlign: 'center', marginBottom: '16px' }}>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
                <span style={{ fontSize: '32px' }}>🎮</span>
                <h2 style={{ 
                  fontSize: '24px', 
                  fontWeight: 'bold', 
                  color: '#ff6ec7', 
                  textShadow: '0 0 10px rgba(255, 110, 199, 0.5)', 
                  margin: 0,
                  fontFamily: "'VT323', monospace",
                  letterSpacing: '1px'
                }}>
                  sophietotoro
                </h2>
                <span style={{ fontSize: '32px' }}>🎯</span>
              </div>
              <p style={{ fontSize: '14px', color: '#b0b0b0', margin: 0 }}>My Valorant ID</p>
            </div>

            {/* Rank Badge */}
            <div style={{ textAlign: 'center', marginBottom: '16px' }}>
              <div style={{
                display: 'inline-block',
                background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #a855f7 100%)',
                border: '2px solid #c084fc',
                boxShadow: '0 0 20px rgba(139, 92, 246, 0.4)',
                padding: '8px 16px',
                borderRadius: '8px'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}>
                  <span style={{ fontSize: '24px' }}>💎</span>
                  <div>
                    <p style={{ fontSize: '12px', color: '#e0e0ff', margin: 0 }}>Peak Rank</p>
                    <p style={{ 
                      fontSize: '20px', 
                      fontWeight: 'bold', 
                      color: '#ffffff', 
                      textShadow: '0 0 10px rgba(255, 255, 255, 0.5)', 
                      margin: 0,
                      fontFamily: "'VT323', monospace",
                      letterSpacing: '1px'
                    }}>Diamond</p>
                  </div>
                  <span style={{ fontSize: '24px' }}>💎</span>
                </div>
              </div>
            </div>

            {/* Video Section */}
            <div style={{ marginBottom: '16px' }}>
              <div style={{ textAlign: 'center', marginBottom: '8px' }}>
                <span style={{ fontSize: '14px', color: '#b0b0b0' }}>✨ Some of my gameplay ✨</span>
              </div>
              <div style={{
                borderRadius: '8px',
                overflow: 'hidden',
                border: '4px solid #f472b6',
                boxShadow: '0 0 20px rgba(255, 110, 199, 0.3)',
                background: '#000'
              }}>
                <iframe
                  src={embedUrl}
                  width="100%"
                  height="350"
                  allow="autoplay; encrypted-media"
                  allowFullScreen
                  title="Valorant Gameplay"
                  style={{ display: 'block', border: 'none' }}
                />
              </div>
              <div style={{ textAlign: 'center', marginTop: '8px' }}>
              </div>
            </div>

            {/* Footer decorations */}
            <div style={{ textAlign: 'center' }}>
              <div style={{ display: 'flex', justifyContent: 'center', gap: '8px', fontSize: '24px' }}>
                <span>⭐</span>
                <span>🎯</span>
                <span>✨</span>
                <span>🔫</span>
                <span>⭐</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

export default ValorantModal;
